import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./styles.module.scss";

interface Props {
  start: Date | null;
  onChangeStart: (value: Date | null) => void;
  end: Date | null;
  onChangeEnd: (value: Date | null) => void;
}

const DateRangeInputs: React.FC<Props> = (props) => {
  return (
    <div className={styles.container}>
      <div className={styles.subContainer}>
        <div className={styles.titleContainer}>
          <span className={styles.title}>From</span>
          <button
            type="button"
            className={styles.button}
            onClick={() => props.onChangeStart(null)}
          >
            Clear
          </button>
        </div>
        <DatePicker
          selected={props.start}
          onChange={(value) => props.onChangeStart(value)}
          className={styles.dateInput}
          onFocus={(e) => e.target.blur()}
          maxDate={props.end ? props.end : undefined}
        />
      </div>
      <div className={styles.subContainer}>
        <div className={styles.titleContainer}>
          <span className={styles.title}>To</span>
          <button
            type="button"
            className={styles.button}
            onClick={() => props.onChangeEnd(null)}
          >
            Clear
          </button>
        </div>
        <DatePicker
          selected={props.end}
          onChange={(value) => props.onChangeEnd(value)}
          className={styles.dateInput}
          onFocus={(e) => e.target.blur()}
          minDate={props.start ? props.start : undefined}
        />
      </div>
    </div>
  );
};

export default DateRangeInputs;
